export const locales: { [k: string]: string } = {
  en: 'English',
  es: 'Español',
}

export const localeOptions = Object.entries(locales).map(([value, label]) => ({ value, label }))
